import { render, staticRenderFns } from "./_orgchartPanal.vue?vue&type=template&id=16388dcc"
import script from "./_orgchartPanal.vue?vue&type=script&lang=js"
export * from "./_orgchartPanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports